<ngx-spinner name="Main"></ngx-spinner>
<router-outlet></router-outlet>
